import type { SiblingItem } from '../types/nav';

/**
 * SF-146: single source of truth for which pages belong to the War Part, consumed by both
 * `WarHub` and `SiblingRow`. Mirrors Sidebar.tsx's NAV_SECTIONS "Operations" section item-for-item
 * (same routes, same icon paths, same pillar assignments) — reuses that taxonomy rather than
 * inventing a new one, following `REALM_ITEMS`'s existing precedent (full taxonomy unification
 * explicitly deferred).
 */
export const WAR_ITEMS: readonly SiblingItem[] = [
  { key: 'attack',   label: 'War Room', route: '/attack',   pillar: 'military', iconPath: 'M2 3H14L13 8H3ZM4 8V13H12V8M8 3V8' },
  { key: 'mystics',  label: 'Mystics',  route: '/mystics',  pillar: 'military', iconPath: 'M8 2L10 6L14 7L11 10L12 14L8 12L4 14L5 10L2 7L6 6Z' },
  { key: 'thievery', label: 'Thievery', route: '/thievery', pillar: 'military', iconPath: 'M8 3A3 3 0 006 6V8H10V6A3 3 0 008 3ZM5 8H11V13H5Z' },
];
